import { formatLicense } from '../format/formatLicense'
import { typeEmpty } from '../type/typeEmpty'

/**
 * @desc 验证是否营业执照格式
 * @param {boolean} required
 * @param {String} validateValue
 * @param {*} callback
 * @param {String} field
 * @param {String} [action]
 */
export const vLicense = (required: boolean, validateValue: string, callback: any, field: string = '统一信用代码', action: string = '填写'): void => {
  if (!required && !validateValue) {
    callback()
  } else {
    if (typeEmpty(validateValue)) {
      action = action || '填写'
      callback(new Error(`${field}必须${action}`))
    } else {
      if (formatLicense(validateValue)) {
        callback()
      } else {
        callback(new Error(`${field}格式不正确`))
      }
    }
  }
}
